export type PlanfixImportStatus = 'STARTED' | 'SUCCESS' | 'FAILED' | 'PARTIAL';

export interface PlanfixImportRun {
  id: string;
  startedAt: string;
  updatedAt: string;
  finishedAt: string | null;
  durationMillis: number | null;
  status: PlanfixImportStatus;
  phase: string;
  groupsProcessed: number;
  usersProcessed: number;
  errors: number;
  truncated: boolean;
  loggingIncomplete: boolean;
}

export interface PlanfixImportPage {
  items: PlanfixImportRun[];
  hasMore: boolean;
}

export interface PlanfixImportRow extends PlanfixImportRun {
  statusKey: string;
  phaseKey: string;
}

export const PLANFIX_IMPORT_STATUS_KEYS = {
  STARTED: 'PLANFIX_IMPORT_STATUS_STARTED',
  SUCCESS: 'PLANFIX_IMPORT_STATUS_SUCCESS',
  FAILED: 'PLANFIX_IMPORT_STATUS_FAILED',
  PARTIAL: 'PLANFIX_IMPORT_STATUS_PARTIAL',
};

export const PLANFIX_IMPORT_PHASE_KEYS: { [phase: string]: string } = {
  'starting': 'PLANFIX_IMPORT_PHASE_STARTING',
  'reading Planfix structure': 'PLANFIX_IMPORT_PHASE_READING',
  'recovering saved standard operations': 'PLANFIX_IMPORT_PHASE_RECOVERING',
  'preparing parent departments': 'PLANFIX_IMPORT_PHASE_PARENTS',
  'importing sections': 'PLANFIX_IMPORT_PHASE_SECTIONS',
  'ordinary departments': 'PLANFIX_IMPORT_PHASE_DEPARTMENTS',
  'deferred memberships': 'PLANFIX_IMPORT_PHASE_MEMBERSHIPS',
};

export const PLANFIX_IMPORT_ACTION = {
  VIEW: 'view' as 'view',
  COPY: 'copy' as 'copy',
  DOWNLOAD: 'download' as 'download',
};

export type PlanfixImportAction = typeof PLANFIX_IMPORT_ACTION.VIEW
  | typeof PLANFIX_IMPORT_ACTION.COPY | typeof PLANFIX_IMPORT_ACTION.DOWNLOAD;



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/planfix-import-journal/planfix-import-journal.model.ts